$(document).ready(function() {
  //Smooth scrolling
  $("a.smooth-scroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });


  $("a.smooth-scroll-middle").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top - ($(window).height()/2)
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });

});

/* Start Drag Slider Functionality. */
(function ($) {

var sliders = $('.draggable-slider');


$(sliders).each(function(){
  
  var slider = $(this);
  var isDown = false;
  var startX;
  var scrollLeft;
  var walk;

  slider.on('mousedown', (e) => {
    isDown = true;
    slider.addClass('active');
    startX = e.pageX - slider.offset().left;
    scrollLeft = slider.scrollLeft();
  });
  slider.on('mouseleave', () => {
    isDown = false;
    slider.removeClass('active');
  });
  slider.on('mouseup', (e) => {
    isDown = false;
    slider.removeClass('active');
    slider.removeClass("prevent-clickable-links");
  });
  slider.on('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    var x = e.pageX - slider.offset().left;
    walk = (x - startX); //scroll-fast
    slider.scrollLeft(scrollLeft - walk);

    if( (walk > 20 || walk < -20) && !slider.hasClass("prevent-clickable-links") ){
      slider.addClass("prevent-clickable-links");
    }
  });
});

})(jQuery);
/* End Drag Slider Functionality. */

/* Start Play On Scroll Functionality. */
(function ($) {

  $(window).load(function() {

    $('.video-container').each(function(){
      var video_container = this;
      var video = $(video_container).find('.video-element');
      var video_controller = $(video_container).find('.video-controller');

      // Add click event for pause/play button.
      $(video_controller).on('click', function(){
        if($(video_container).hasClass('force-pause')){
          $(video_container).removeClass('force-pause');
          playVideo(video);
        }else{
          $(video_container).addClass('force-pause');
          pauseVideo(video);
        }
      });

      // Check if the video is visible on load. Play the video if it is visible and pause the video if it is not.
      if(isElementVisible(video_container)){
        playVisibleVideo(video_container, video);
      }else{
        pauseHiddenVideo(video_container, video);
      }

      // Check if the video is visible whenever the user scrolls or resizes the screen.
      $(window).on("scroll resize", function(){
        videoVisibilityCheck(video_container, video);
      });
    });

    // Check if video is visible and play the video if it is or pause the video if it is not.
    // -Check for playing class to determine if the video is already playing or paused to prevent redundant actions.
    // -Check for paused videos to prevent playing a video that the user has paused. 
    function videoVisibilityCheck(video_container, video) {
      if (isElementVisible(video_container)) {
        if(   !$(video_container).hasClass('playing') && 
              !$(video_container).hasClass('force-pause')){
          playVisibleVideo(video_container, video);
        }
      } else if($(video_container).hasClass('playing')){
        pauseHiddenVideo(video_container, video);
      }
    }

    // Play video and add playing class to container.
    function playVisibleVideo(video_container, video) {
      $(video_container).addClass('playing');
      playVideo(video);
    }

    // Pause video and remove playing class from container.
    function pauseHiddenVideo(video_container, video) {
      $(video_container).removeClass('playing');
      pauseVideo(video);
    }

    function playVideo(video) {
      console.log("playing video");
      video.each(function(){
        if($(this).is(":visible"))
          $(this).trigger('play');
      });
    }

    function pauseVideo(video) {
      console.log("pausing video");
      video.each(function(){
        if($(this).is(":visible"))
          $(this).trigger('pause');
      });
    }

    function isElementVisible ($containter, threshold) {

      // Return not visible if video is hidden through styling.
      var video = $($containter).find('.video-element');
      if(!$(video).is(':visible')){
          return false;
      }


      // Calculate if the element is currently in view.
      var rect = $containter.getBoundingClientRect();
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      threshold = threshold ? threshold : 0;

      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (windowHeight + threshold) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };
  });

})(jQuery);
/* End Play On Scroll Functionality. */

/* Start Find In Store Functionality. */
(function ($) {

  $('.find-in-store').each(function(){
    var container = $(this);
    var product_id = container.data('product-id');
    var variant_array = container.data('variant-array');
    
    //guard function
    if(product_id === undefined || product_id == "" ) return;

    var mw_api = container.data('mw-api');
    var form = container.find('.store-search-form');
    var zip = container.find('.store-zip');
    var distance = container.find('.store-distance');
    var submit = container.find('.store-submit');
    var results = container.find('.store-results');

    $(form).on('submit', function(e){
      e.preventDefault();
      var zip_code = zip.val();
      var search_distance = distance.val();

      if(zip_code != ""){
        //search goes here
        getStores(product_id, zip_code, search_distance, mw_api, variant_array, results);
      }
    });
  });

  var getStores = function getStores(product_id, zip_code, search_distance, mw_api, variant_array, results){
    
    var getstoreinventory_api_url = `${mw_api}/StoreInventory/GetStyleInventoryByLocation`; //`${mw_api}/StoreInventory/${zip_code}/${product_id}`; //update

    data_arr = { 
      "StoreNumber": 1,
      'StyleCode': product_id,
      'ZipCode': zip_code,
      "Radius": search_distance
    }; 

    /*    

    data_arr = { 
      "StoreNumber": 1,
      'StyleCode': "153422",
      'ZipCode': "08043",
      "Radius": search_distance
    };

    variant_array = { "7821700015": "6", "7821700016": "7", "7821700017": "8", "7821700018": "9", "7821700019": "10", "7821700020": "11", "7821700047": "12" };

    */


    $.ajax({
      type: "POST",
      url: getstoreinventory_api_url,
      dataType: "json",
      data: data_arr,

      error: function (e) {
          console.log("XML reading Failed: ", e);
          $(results).children().remove();
          $(results).append("<p>Sorry no stores found in your location.</p>");
      },

      success: function (response) {

        var results_html = "";
        var results_arr = [];
        var has_results = false;

        $(results).children().remove();

        if (response != null){

          results_html += '<div class="store_result-container dtlr-scroll">';

          for (var store of response.StoreInventoryCollection ){
            has_results = true; 
            var store_html = '';

            var store_address = '';
            if (store.StoreDetails.store_address_1) store_address += `${store.StoreDetails.store_address_1} `;
            if (store.StoreDetails.store_address_2) store_address += `${store.StoreDetails.store_address_2} `;
            if (store.StoreDetails.store_city) store_address += `${store.StoreDetails.store_city} `;
            if (store.StoreDetails.store_state) store_address += `${store.StoreDetails.store_state} `;
            if (store.StoreDetails.store_zipcode) store_address += `${store.StoreDetails.store_zipcode}`;

            var store_phone = store.StoreDetails.store_phone;
            store_phone = store_phone.split("-").join("");

            var store_uptodatestock = store.UpToDateStock;

            var directions_url = store_address.split(' ').join('+');
            directions_url = 'https://www.google.com/maps/dir/?api=1&destination=' + store_address;

            store_html += '<div class="store_result-element">';

            store_html +=   '<div class="store_result-info">';
            store_html +=     `<h3 class="store_result-name">${store.StoreDetails.store_name}</h3>`;
            store_html +=     `<p class="store_result-address">${store_address}</p>`;
            store_html +=     `<a class="store_result-phone" href="tel:${store_phone}">${store.StoreDetails.store_phone}</a>`;
            store_html +=     `<a class="store_result-directions" target="_blank" href="${directions_url}">Get Directions</a>`;
            store_html +=     `<p class="store_result-distance">${store.StoreDetails.distance} Mi</p>`;
            store_html +=   '</div>';


            var item_stock = 0;
            var has_limited_stock = false;
            var item_array = [];

            if(store_uptodatestock){

              store_html +=   '<div class="store_result-variants">';

              for(var store_item of store.Inventory){
                var sku_name = variant_array[store_item.sku];
                var limited_stock = '';
                var item_html = '';

                if(store_item.quantity > 0){
                  item_stock += store_item.quantity;
                  //has_results = true; // Set results to true if any store has quantity over 0 otherwise treat as no stores returned.
                  if(store_item.quantity <= 2){
                    has_limited_stock = true;
                    limited_stock = 'limited';
                  }

                  item_html = `<div class="store_result-variant ${limited_stock}"><p class="store_result-variant-name">${sku_name}</p></div>`;
                  item_array.push( { html: item_html, sku: sku_name } );
                }
              }

              // Sort numeric sizes smallest to largest and ignore non numeric sizes.
              item_array.sort(function(a, b){ 

                if( isNaN(Number(a.sku)) || isNaN(Number(b.sku)) ){
                  return 0;
                }
                else if (Number(a.sku) > Number(b.sku)){
                  return 1;
                }
                else{
                  return -1;
                }

              });

              for (var item_element of item_array){
                store_html += item_element.html;
              }

              store_html +=   '</div>';
            }


            if(!store_uptodatestock || item_stock == 0)
              store_html += '<p class="store_result-contact">Contact Store For Availability</p>';
            else if(has_limited_stock)
              store_html += '<p class="store_result-limited">Limited Stock</p>';

            store_html += '</div>';

            // Add if statement back in to remove sold out stores.
            // if(item_stock > 0){
              results_arr.push( { html: store_html, distance: parseFloat(store.StoreDetails.distance) } );
            // }
          }

          results_arr.sort((a, b) => (a.distance > b.distance) ? 1 : -1);

          for (var store_result of results_arr){
            results_html += store_result.html;
          }

          results_html += '</div>';

        }

        // If no results were returned show no results found instead of an empty container.
        if(!has_results){
          results_html = "<p>No stores with this product were found near your location.</p>"
        }

        $(results).append(results_html);


        var accordion = results.closest('.dtlr_accordion');
        if(accordion.length && accordion.hasClass('active')){
          console.log("found parrent accordion");
          var accordion_content = accordion.find('.dtlr_accordion-content');
          var accordion_content_inner = accordion.find('.dtlr_accordion-content-inner');
          var store_result_container = accordion.find('.store_result-container');
          accordion_content.css("max-height", accordion_content_inner.outerHeight() + 'px');
          accordion_content.css("height", accordion_content_inner.outerHeight() + 'px');
          store_result_container.css("height", accordion_content_inner.outerHeight() + 'px');
          console.log(accordion_content_inner.outerHeight() + 'px');
          console.log(accordion_content_inner.innerHeight() + 'px');
        }

      }
    });

  };

})(jQuery);
/* End Play On Scroll Functionality. */

/* Begin Toast Function */
/* Toast is a custom popup to appear at the bottom of the screen */
function makeToast(toast_message, toast_time, $focus_after_toast) {
    var x = document.getElementById("toast");
    x.textContent = toast_message;
    x.className = "show";
    $("#toast").attr("tabindex", -1).focus();
    setTimeout(function() { x.className = x.className.replace("show", "");
        $focus_after_toast.focus(); }, toast_time);
}
/* End Toast Fucntion */

/* Begin Accordion functions */

(function ($) {
  // DTLR Accordion
  /*
    <div class="dtlr_accordion dtlr_accordion-primary">
      <div class="dtlr_accordion-trigger">
        <!-- Trigger Here -->
      </div>
      <div class="dtlr_accordion-content">
        <div class="dtlr_accordion-content-inner">
          <!-- Content Here -->
        </div>
      </div>
    </div>
  */
  $('.dtlr_accordion').not('.dtlr-page-filter-accordion').each(function(){
    var accordion_parent = $(this);
    var accordion_trigger = accordion_parent.find('.dtlr_accordion-trigger');
    var accordion_content = accordion_parent.find('.dtlr_accordion-content');
    var accordion_content_inner = accordion_content.find('.dtlr_accordion-content-inner');

    accordion_trigger.attr("tabindex", 0);

    accordion_trigger.on('click', function(event){
      if(accordion_parent.hasClass("active")){
        accordion_parent.removeClass("active");
        accordion_content.css("max-height", "0px");
      }else{
        accordion_parent.addClass("active");
        accordion_content.css("max-height", accordion_content_inner.innerHeight() + "px");
      }
    });
    accordion_trigger.on('keypress', function(event){
      if (event.keyCode === 13) {
        if(accordion_parent.hasClass("active")){
          accordion_parent.removeClass("active");
          accordion_content.css("max-height", "0px");
        }else{
          accordion_parent.addClass("active");
          accordion_content.css("max-height", accordion_content_inner.innerHeight() + "px");
        }
      }
    });
  });
})(jQuery);

/* End Accordion function */

/* Begin Footer functions */

(function ($) {
  // Footer Newsletter funtion
  $('.NewsLetterForm').each(function(){
    var nl_form = $(this);
    var nl_name = nl_form.find('input[name="contact[name]"]');
    var nl_email = nl_form.find('input[name="contact[email]"]');

    nl_form.on('submit', function(){
      if (nl_email.length != 0 ){
        nl_email.val(nl_name.val());
      }
    });
  });

  // Footer Text Sign Up Functions
  $('.text-alert-sign-up').on('click', function(){

    var popup = $(this).closest('.footer').find('.footer-text-popup');
    var container = $(this).closest('.footer').find('.footer-text-popup-container');
    var close = $(this).closest('.footer').find('.footer-close');

    if(!popup.hasClass('transitioning')){
      popup.addClass('open').css('height', container.height());
      close.focus();
    }
  });
  $('.footer-close').on('click', function(){

    var popup = $(this).closest('.footer').find('.footer-text-popup');
    var button = $(this).closest('.footer').find('.text-alert-sign-up');

    if(!popup.hasClass('transitioning')){

      button.focus();
      popup.css('height', 0).addClass('transitioning');

      setTimeout( function(){ 
        popup.removeClass('open').removeClass('transitioning');
      }  , 1000 );
    }
  });
})(jQuery);

/* End Footer Text function */

/* Begin Enter to Click functions */
/* 
  Adding the class enter-to-click to an element will cause that 
  element to have a tabindex and cause enter to fire a click event 
  this is useful for non a and button tagged elements that are clickable
*/

function init_enter_to_click(){
  // Find elements that should be able to be clicked with the enter key.
  $('.enter-to-click').each(function(){

    // Initialize once. Function may be called more than once.
    if(!$(this).hasClass("init")){
      $(this).addClass("init");

      // Update tabindex property of non a and button tagged elements to allow them to be focusable.
      if( $(this).prop("tagName") != "A" && $(this).prop("tagName") != "BUTTON" && !$(this).attr('tabindex')){
        $(this).attr('tabindex', "0");
      }
      // When focued on an enter to click element and the enter button is pressed fire 
      $(this).on('keypress', function(e){
        if (!$(this).hasClass('disabled') && e.keyCode == 13) {
          $(this).trigger('click');
        }
      });
    }
  });
}
// Automatically run on startup.
init_enter_to_click();


// (function ($) {
//   // Update tabindex property of non a and button tagged elements to allow them to be focusable.
//   $('.enter-to-click').each(function(){
//     if( $(this).prop("tagName") != "A" && $(this).prop("tagName") != "BUTTON" && !$(this).attr('tabindex')){
//       $(this).attr('tabindex', "0");
//     }
//   });
//   // When focued on an enter to click element and the enter button is pressed fire 
//   $('.enter-to-click').on('keypress', function(e){
//     if (!$(this).hasClass('disabled') && e.keyCode == 13) {
//       $(this).trigger('click');
//     }
//   });
// })(jQuery);


/* End Enter to Click functions */
function openCity(evt, cityName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("faq-tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
  tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
  tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the link that opened the tab
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}  
// document.getElementById("defaultOpen").click();

// Add GTM pixel calls on click of certain elements
(function ($) {

  // Color GTM
  $('.color-item-link').on('click', function(e){
    e.preventDefault();
    // Fire GTM Tag
    Shopify.analytics.publish('color_swatch', {});
    // Navigate to next page if link exists.
    if($(this).prop('href'))
      window.location = $(this).prop('href');
  });
  // Size GTM
  $('.size-item-link').on('click', function(e){
    e.preventDefault();
    // Fire GTM Tag
    Shopify.analytics.publish('size_selector', {});
    // Navigate to next page if link exists.
    if($(this).prop('href'))
      window.location = $(this).prop('href');
  });
  // Looks GTM 
  $('.looks-item-link').on('click', function(e){
    e.preventDefault();
    // Fire GTM Tag
    Shopify.analytics.publish('complete_look', {});
    // Navigate to next page if link exists.
    if($(this).prop('href'))
      window.location = $(this).prop('href');
  });
  // CS Button GTM
  $('.cs-btn').on('click', function(e){
    e.preventDefault();
    // Fire GTM Tag
    Shopify.analytics.publish('cs_button', {});
    // Navigate to next page if link exists.
    if($(this).prop('href'))
      window.location = $(this).prop('href');
  });
})(jQuery);

// Play product videos on scroll
(function($){

  // Create observer to fire when a video has been scrolled into view.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = $(entry.target).find("video");
        
        // Check for paused class. Only trigger play once.
        if(!video.hasClass("paused") && !video.hasClass("played")){
          video.addClass("played");
          video.trigger("play");
        }
      }
    });
  }, {
    rootMargin: '0px',
    threshold: 0.1
  });

  $(".product_video").each(function(){
    
    // Add click event to play and pause each video.
    $(this).on("click", function(){
      const video = $(this).find('video');
      if(!video.hasClass("paused"))
        video.trigger("pause");
      else
        video.trigger("play");
      
      video.toggleClass("paused");
    });

    // Add observer to each video.
    observer.observe($(this).get(0));
  });

})(jQuery);

// Redirect to home if on the home page of a custom screen.
(function($){
  $(window).load(function() {

    $(".tapcart-link").removeClass("disabled");

    // If Tapcart App
    if(!window.Tapcart?.isInitialized)
      return;
    
    // Home redirect
    if(location.pathname == "/"){
      Tapcart.actions.openScreen({
        destination: { type: "internal", url: "/home" }
      });
    }

    $(".tapcart-link").on('click', function(e){
      e.preventDefault();

      Tapcart.actions.openScreen({
        destination: { type: "internal", url: `${$(this).data('custom-screen-id')}` }
      });
    });
  });
})(jQuery);